import type { Market } from '@//config/domain-locale-map';

const AvailableFiltersWayke = [
  'location',
  'manufacturer',
  'modelSeries',
  'modelYear',
  'price',
  'gearboxType',
  'mileage',
  'fuelType',
  'fuelTypes',
  'engineBaseType',
  'enginePower',
  'enhancedProperties.electricalRangeWLTP.value',
  'chassis',
  'drivingWheel',
  'properties.segment',
  'color',
  'properties.seats',
  'environmentClass',
  'branches',
  'properties.co2',
  'inventoryStatus',
  'deductibleVat',
  'mrf',
  'isAuthorizedResellerForManufacturer',
  'hasManufacturerPackaging',
  'hasMedia',
  'ecom',
  'leasing',
  'businessLeasing',
  'isAuctionItem',
];

const AvailableFiltersDrive = [
  'location',
  'manufacturer',
  'modelSeries',
  'modelYear',
  'price',
  'gearboxType',
  'odometerValueAsKm',
  'fuelType',
  'fuelTypes',
  'engineBaseType',
  'enginePower',
  'enhancedProperties.electricalRangeWLTP.value',
  'chassis',
  'drivingWheel',
  'properties.segment',
  'color',
  'properties.seats',
  'environmentClass',
  'branches',
  'properties.co2',
  'inventoryStatus',
  'deductibleVat',
  'mrf',
  'isAuthorizedResellerForManufacturer',
  'hasManufacturerPackaging',
  'hasMedia',
  'leasing',
  'businessLeasing',
  'isAuctionItem',
];

export const DeprecatedFilters = ['fuelType'];

const AvailableFilters = {
  wayke: AvailableFiltersWayke,
  drive: AvailableFiltersDrive,
};

export const resolveAvailableFilters = (market: Market) => AvailableFilters[market];

const QuickFiltersWayke = [
  'manufacturer',
  'modelSeries',
  'location',
  'modelYear',
  'price',
  'mileage',
];

const QuickFiltersDrive = [
  'manufacturer',
  'modelSeries',
  'location',
  'modelYear',
  'price',
  'odometerValueAsKm',
];

const QuickFilters = {
  wayke: QuickFiltersWayke,
  drive: QuickFiltersDrive,
};

export const resolveQuickFilters = (market: Market) => QuickFilters[market];
